import { Card, Col, Row, Badge } from "react-bootstrap";
import brokerageLogo from "assets/img/team/image.png";
import subscribe from "assets/img/team/image.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faFileLines, 
  faBuilding, 
  faImage, 
  faUser, 
} from "@fortawesome/free-solid-svg-icons";

const CompanyProfileCard = () => {
  return (
    <>
      {/* AI-Enhanced Company Profile Card */}
      <Card 
        className="border-0 mb-4 ai-hover-lift"
        style={{
          background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)',
          backdropFilter: 'blur(15px)',
          border: '1px solid rgba(0, 212, 255, 0.2) !important',
          borderRadius: '20px',
          boxShadow: '0 10px 40px rgba(0, 212, 255, 0.1)',
          overflow: 'hidden'
        }}
      >
        {/* AI Intelligence Header */}
        <Card.Header 
          className="border-bottom-0 py-4"
          style={{ 
            background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%)',
            backdropFilter: 'blur(10px)',
            borderRadius: '20px 20px 0 0'
          }}
        >
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div 
                className="rounded-circle d-flex align-items-center justify-content-center me-3"
                style={{ 
                  width: "40px", 
                  height: "40px",
                  background: 'linear-gradient(135deg, #00d4ff 0%, #0ea5e9 100%)',
                  boxShadow: '0 0 15px rgba(0, 212, 255, 0.4)'
                }}
              >
                <FontAwesomeIcon 
                  icon={faBuilding} 
                  className="text-white" 
                  style={{ filter: 'drop-shadow(0 0 4px rgba(255, 255, 255, 0.5))' }}
                />
              </div>
              <div>
                <h5 style={{ 
                  color: '#1f2937',
                  textShadow: '0 0 10px rgba(0, 212, 255, 0.3)',
                  fontSize: '1.1rem',
                  fontWeight: 600,
                  marginBottom: '2px'
                }}>
                  Company Profile Intelligence
                </h5>
                <small className="text-muted" style={{ fontSize: '12px' }}>
                  AI-powered business insights
                </small>
              </div>
            </div>
            
            {/* AI Status Badge */}
            <Badge 
              bg="transparent" 
              className="fw-semibold"
              style={{
                background: 'linear-gradient(135deg, rgba(245, 158, 11, 0.1) 0%, rgba(217, 119, 6, 0.1) 100%)',
                color: '#f59e0b',
                border: '1px solid rgba(245, 158, 11, 0.3)',
                fontSize: '10px',
                padding: '6px 12px',
                borderRadius: '15px',
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}
            >
              <div className="rounded-circle me-1 d-inline-block" style={{
                width: '6px', height: '6px', background: '#f59e0b',
                animation: 'pulse 2s infinite'
              }} />
              Setup
            </Badge>
          </div>
        </Card.Header>

        <Card.Body className="p-4" style={{ background: 'transparent' }}>
          {/* Company Name Section */}
          <div 
            className="mb-4 p-3 rounded-3 text-center"
            style={{
              background: 'rgba(0, 212, 255, 0.05)',
              border: '1px solid rgba(0, 212, 255, 0.1)'
            }}
          >
            <FontAwesomeIcon 
              icon={faBuilding} 
              className="text-primary mb-2" 
              size="2x"
              style={{ color: '#00d4ff' }}
            />
            <h3 style={{ 
              color: '#1f2937',
              textShadow: '0 0 10px rgba(0, 212, 255, 0.2)',
              fontWeight: 600,
              marginBottom: '8px'
            }}>
              Brokerage Name
            </h3>
            <p className="text-muted mb-0" style={{ fontSize: '14px' }}>
              AI-enhanced company profile
            </p>
          </div>

          {/* Logo and Photo Section */}
          <Row className="align-items-start g-3 text-center">
            <Col xs={6}>
              <div 
                className="p-3 rounded-3 ai-hover-lift h-100"
                style={{
                  background: 'linear-gradient(135deg, rgba(16, 185, 129, 0.1) 0%, rgba(5, 150, 105, 0.1) 100%)',
                  border: '1px solid rgba(16, 185, 129, 0.2)',
                  transition: 'all 0.3s ease'
                }}
              >
                <div 
                  className="rounded-3 d-flex align-items-center justify-content-center mb-3"
                  style={{
                    background: 'rgba(255, 255, 255, 0.8)',
                    border: '2px dashed rgba(16, 185, 129, 0.3)',
                    height: '80px'
                  }}
                >
                  <img 
                    src={brokerageLogo} 
                    alt="Brokerage Logo" 
                    style={{ 
                      width: '50px', 
                      height: '50px',
                      objectFit: 'cover',
                      borderRadius: '8px',
                      filter: 'drop-shadow(0 2px 8px rgba(16, 185, 129, 0.2))'
                    }} 
                  />
                </div>
                <div className="d-flex align-items-center justify-content-center mb-2">
                  <FontAwesomeIcon 
                    icon={faImage} 
                    className="me-2" 
                    style={{ color: '#10b981' }}
                  />
                  <h6 className="mb-0 fw-semibold" style={{ color: '#1f2937' }}>
                    Brokerage Logo
                  </h6>
                </div>
                <small className="text-muted">AI optimized</small>
              </div>
            </Col>

            <Col xs={6}>
              <div 
                className="p-3 rounded-3 ai-hover-lift h-100"
                style={{
                  background: 'linear-gradient(135deg, rgba(139, 92, 246, 0.1) 0%, rgba(124, 58, 237, 0.1) 100%)',
                  border: '1px solid rgba(139, 92, 246, 0.2)',
                  transition: 'all 0.3s ease'
                }}
              >
                <div 
                  className="rounded-3 d-flex align-items-center justify-content-center mb-3"
                  style={{
                    background: 'rgba(255, 255, 255, 0.8)',
                    border: '2px dashed rgba(139, 92, 246, 0.3)',
                    height: '80px'
                  }}
                >
                  <img 
                    src={subscribe} 
                    alt="Subscriber Photo" 
                    style={{ 
                      width: '50px', 
                      height: '50px',
                      objectFit: 'cover',
                      borderRadius: '50%',
                      filter: 'drop-shadow(0 2px 8px rgba(139, 92, 246, 0.2))'
                    }} 
                  />
                </div>
                <div className="d-flex align-items-center justify-content-center mb-2">
                  <FontAwesomeIcon 
                    icon={faUser} 
                    className="me-2" 
                    style={{ color: '#8b5cf6' }}
                  />
                  <h6 className="mb-0 fw-semibold" style={{ color: '#1f2937' }}>
                    Subscriber Photo
                  </h6>
                </div>
                <small className="text-muted">AI processed</small>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* AI-Enhanced Attachments Card */}
      <Card 
        className="border-0 ai-hover-lift"
        style={{
          background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)',
          backdropFilter: 'blur(15px)',
          border: '1px solid rgba(0, 212, 255, 0.2) !important',
          borderRadius: '20px',
          boxShadow: '0 10px 40px rgba(0, 212, 255, 0.1)'
        }}
      >
        {/* Attachments Header */}
        <Card.Header 
          className="border-bottom-0 py-4"
          style={{ 
            background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%)',
            backdropFilter: 'blur(10px)',
            borderRadius: '20px 20px 0 0'
          }}
        >
          <div className="d-flex align-items-center">
            <div 
              className="rounded-circle d-flex align-items-center justify-content-center me-3"
              style={{ 
                width: "40px", 
                height: "40px",
                background: 'linear-gradient(135deg, #00d4ff 0%, #0ea5e9 100%)',
                boxShadow: '0 0 15px rgba(0, 212, 255, 0.4)'
              }}
            >
              <FontAwesomeIcon 
                icon={faFileLines} 
                className="text-white" 
                style={{ filter: 'drop-shadow(0 0 4px rgba(255, 255, 255, 0.5))' }}
              />
            </div>
            <div>
              <h6 className="mb-1" style={{ 
                color: '#1f2937',
                textShadow: '0 0 10px rgba(0, 212, 255, 0.3)',
                fontWeight: 600
              }}>
                Document Intelligence
              </h6>
              <small className="text-muted">AI-analyzed business documents</small>
            </div>
          </div>
        </Card.Header>

        <Card.Body className="p-4" style={{ background: 'transparent' }}>
          <div style={{ maxHeight: "400px", overflowY: "auto" }}>
            {/* Placeholder for when no attachments exist */}
            <div 
              className="text-center py-5"
              style={{
                background: 'rgba(156, 163, 175, 0.05)',
                borderRadius: '16px',
                border: '2px dashed rgba(156, 163, 175, 0.2)'
              }}
            >
              <FontAwesomeIcon 
                icon={faFileLines} 
                size="3x" 
                className="text-muted mb-3"
                style={{ opacity: 0.3 }}
              />
              <h6 className="text-muted mb-2">No Business Documents</h6>
              <p className="text-muted mb-0" style={{ fontSize: '14px' }}>
                Upload business documents to unlock AI insights
              </p>
            </div>
          </div>
        </Card.Body>
      </Card>

      {/* AI Animation Styles */}
      <style dangerouslySetInnerHTML={{
        __html: `
          .ai-hover-lift {
            transition: all 0.3s ease;
          }
          
          .ai-hover-lift:hover {
            transform: translateY(-2px);
            box-shadow: 0 15px 35px rgba(0, 212, 255, 0.15) !important;
          }
          
          @keyframes pulse {
            0%, 100% { 
              opacity: 1; 
              transform: scale(1); 
            }
            50% { 
              opacity: 0.7; 
              transform: scale(1.1); 
            }
          }
        `
      }} />
    </>
  );
};

export default CompanyProfileCard;
